/**
 * Configuration for localization resources.
 * This file maps locales to their respective translation files and provides a method
 * to dynamically load translations based on the requested locale.
 */

// Mapping of locales to their relative paths.
const config: Record<string, string> = {
  ar: "ar",
  az: "az",
  de: "de",
  en: "en",
  es: "es",
  fr: "fr",
  it: "it",
  ja: "ja",
  ka: "ka",
  ko: "ko",
  nl: "nl",
  pl: "pl",
  pt: "pt",
  ro: "ro",
  tr: "tr",
  uk: "uk",
  vi: "vi",
  zh: "zh",
  zu: "zu",
};

interface TranslationResult {
  locale: string;
  messages: Record<string, unknown>;
}

/**
 * Dynamically fetches the translation for the given locale.
 *
 * @param locale - The desired locale for translations.
 * @returns A promise that resolves with the locale and its messages.
 */
export const fetchTranslations = async (
  locale: string
): Promise<TranslationResult> => {
  // Check if the provided locale is available in the config resources. If not, default to English.
  const availableLocale = config[locale] ? locale : "en";

  // Dynamically import the required translation file.
  const messages = await import(`./${config[availableLocale]}/translation.json`);

  return {
    locale: availableLocale,
    messages,
  };
};
